import { render, staticRenderFns } from "./KindOfSportsPage.vue?vue&type=template&id=1c50934f&"
import script from "./KindOfSportsPage.vue?vue&type=script&lang=js&"
export * from "./KindOfSportsPage.vue?vue&type=script&lang=js&"
import style0 from "./KindOfSportsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports